import { TableColumn } from '@swimlane/ngx-datatable';
import { FiltroDevolucion } from './filtro-devolucion';
import { Page } from './page';
import { IPaginationElement } from './pagination';
import { SolicitudMaterial } from './solicitud-materiales';

export class HistoricoServicio {
  USUARIO: string;
  NOMBREYAPES: string;
  FECHA: Date;
  ESTADO_INICIAL: string;
  ESTADO_FINAL: string;
  SITUACION_INICIAL: string;
  SITUACION_FINAL: string;
  constructor() { }
}

export class FiltrosContenidos {
  IdSerie: number;
  NombreTipoServicio: string;
  FiltroCampos: any[];
  TotalElementsInventory: number;
  FiltroContenidos: FiltroDevolucion;
  IsDevolucionSolicitud: boolean;

  constructor() { }
}


export class ContenidoSolicitud implements IPaginationElement {
  id: number;
  Campos: [{
    NAME: string,
    PRINCIPAL: boolean,
    VALUE: string,
    ID: number,
    DESCRIPCION: string
  }];
  Situacion: {
    Id: number,
    NOMBRE: string
  };
  Estado: {
    Id: number,
    NOMBRE: string
  };
  ID_CONTENIDO: number;
  FECHA_EXPIRACION: Date;
  FECHA_FINALIZACION: Date;
  FECHA_INICIO: Date;
  FECHA_ENTRADA: Date;
  FECHA_FIN_REAL: Date;

  Ficheros: Fichero[];
  isParcial: boolean;
  ObsParcial: string;
  isInventario: boolean;
  ID_EXPEDIENTE_INV: string;
  TipoUnidadDoc: number;
  // 0 => Inicial; 1 => Final; 2 => Pendiente de autorizar; 3 => No autorizado; 4 => Incidencia; null => en curso
  ESTADO_GEN?: number;
  CONTENIDO_RELACIONADO: number;
  SOLICITUD_RELACIONADA: number;
  ID_CONTENEDOR: number;
  NUMERO_CONTENEDOR: number;
  ID_PROVEEDOR: number;
  PROVEEDOR: {
    NOMBRE: string;
    DESCRIPCION: string;
    NOMBRE_CONTACTO: string;
    EMAIL_SOPORTE: string;
    TELEFONO: string;
    Id: number;
  }

  constructor() { }

  static toModel(json: string): ContenidoSolicitud {
    const data = JSON.parse(json);
    if (data === null) {
      return null;
    }

    const toReturn = new ContenidoSolicitud();



    toReturn.Campos = data.Campos || [];
    toReturn.Situacion = data.Situacion;
    toReturn.Estado = data.Estado;

    toReturn.ID_CONTENIDO = data.ID_CONTENIDO;
    toReturn.FECHA_EXPIRACION = data.FECHA_EXPIRACION;
    toReturn.FECHA_FINALIZACION = data.FECHA_FINALIZACION;
    toReturn.FECHA_INICIO = data.FECHA_INICIO;
    toReturn.FECHA_ENTRADA = data.FECHA_ENTRADA;
    toReturn.FECHA_FIN_REAL = data.FECHA_FIN_REAL;

    toReturn.Ficheros = data.Ficheros;
    toReturn.isParcial = data.isParcial;
    toReturn.ObsParcial = data.ObsParcial;
    toReturn.isInventario = data.isInventario;
    toReturn.ID_EXPEDIENTE_INV = data.ID_EXPEDIENTE_INV;
    toReturn.TipoUnidadDoc = data.TipoUnidadDoc;
    toReturn.ESTADO_GEN = data.ESTADO_GEN;
    toReturn.CONTENIDO_RELACIONADO = data.CONTENIDO_RELACIONADO;
    toReturn.SOLICITUD_RELACIONADA = data.SOLICITUD_RELACIONADA;
    toReturn.ID_CONTENEDOR = data.ID_CONTENEDOR;
    toReturn.NUMERO_CONTENEDOR = data.NUMERO_CONTENEDOR;
    toReturn.ID_PROVEEDOR = data.ID_PROVEEDOR;
    toReturn.PROVEEDOR = data.PROVEEDOR;

    return toReturn;
  }
}

export class Fichero {
  Id: number;
  ID_CONTENIDO: number;
  ID_SOLICITUD: number;
  ID_OBSERVACIONES: number;
  GUID: string;
  STATUS: string;
  FECHA: Date;
  NOMBRE_FICHERO: string;

  constructor() { }
}

export class DetalleSolicitud {
  ID_CLIENTE: number;
  NOMBRE_CLIENTE: string;
  ID_SERVICIO: number;
  ID_TIPO_SERVICIO: number;
  NOMBRE_TIPO_SERVICIO: string;
  NOMBRE_ROUTE_SERVICIO: string;
  ID_CREADOR: number;
  NOMBRE_CREADOR: string;
  APELLIDOS_CREADOR: string;
  ID_SOLICITANTE: number;
  NOMBRE_SOLICITANTE: string;
  APELLIDOS_SOLICITANTE: string;
  ID_SERIE: number;
  NOMBRE_SERIE: string;
  ID_DEPARTAMENTO: number;
  NOMBRE_DEPARTAMENTO: string;
  ID_USUARIO_SOLICITANTE: number;
  NOMBRE_USUARIO_SOLICITANTE: string;
  ID_SITUACION_DOCOUT: number;
  NOMBRE_SITUACION_DOCOUT: string;
  ID_ESTADO_DOCOUT: number;
  NOMBRE_ESTADO_DOCOUT: string;
  ID_SITUACION_CLIENTE: number;
  NOMBRE_SITUACION_CLIENTE: string;
  ID_ESTADO_CLIENTE: number;
  NOMBRE_ESTADO_CLIENTE: string;
  ID_DIRECCION: number;
  DIRECCION: {
    DIRECCION: string;
    CODIGO_POSTAL: number;
    POBLACION: string;
    PROVINCIA: string;
    Id: number;
    ID_PROVINCIA: number;
    TELEFONO: number;
    NOMBRE: string;
    POR_DEFECTO: boolean;
    EDITABLE: boolean;
  };
  FECHA_CREACION: Date;
  FECHA_SOLICITUD: Date;
  FECHA_SLA: Date;
  FECHA_FINALIZACION: Date;
  EMAIL: string;
  NORMAL_URGENTE: string;
  TIPO_ENVIO: string;
  FECHA_EXPIRACION: Date;
  NOMBRE_PARAM_SERVICIO: string;
  DESC_PARAM_SERVICIO: string;
  NOMBREYAPES_USUARIO_APROBACION: string;
  GRUPO_APROBACION: {
    ID_ROL: number;
    ID_CLIENTE: number;
    NOMBRE: string;
    DESCRIPCION: string;
    Id: number;
  };
  RANGO_APROBACION: number;
  ES_USUARIO_APROBADOR: boolean;
  ID_USUARIO_APROBACION: number;
  USUARIO_APROBACION: string;
  FicherosCargaMasiva: Fichero[];
  FicherosDocumentacion: Fichero[];
  MANUAL_MASIVA: string;
  // 0 => Inicial; 1 => Final; 2 => Pendiente de autorizar; 3 => No autorizado; 4 => Incidencia; null => en curso
  ESTADO_GEN_SERVICIO?: number;
  CONTADOR_CONTENIDOS: ContadorContenidos;
  PUEDE_ADD_CONTENIDOS: boolean;
  ID_MOTIVO: number;
  MOTIVO: string;
  MOTIVOTEXT: string;
  //🥑🥑 PROVEEDOR
  ID_PROVEEDOR: number;
  PROVEEDOR: {
    NOMBRE: string;
    DESCRIPCION: string;
    NOMBRE_CONTACTO: string;
    EMAIL_SOPORTE: string;
    TELEFONO: string;
    Id: number;
  };
  constructor() { }
}

export class ContadorContenidos {
  NUM_CONTENIDOS_NO_INVENTARIO: number;
  NUM_CONTENIDOS_EXPEDIENTES: number;
  NUM_CONTENIDOS_CONTENEDORES: number;
  NUM_CONTENIDOS_AZ: number;

  constructor() { }
}

export class DataReturnsSelected {
  needDataToShowData?: boolean;
  clientSelected?: number;
  serieId?: number;
  userSelected?: number;
}

export class SituacionContenido {
  SITUACION: { Id: number, NOMBRE: string };
  ESTADO: { Id: number, NOMBRE: string };
  TIPO: string;
  IsCanceled: boolean;
  IsFinalize: boolean;

  constructor() { }
}


export class SituacionSolicitud {
  SITUACION: { Id: number, NOMBRE: string };
  ESTADO: { Id: number, NOMBRE: string };
  TIPO: string;
  IsCanceled: boolean;
  IsFinalize: boolean;

  constructor() { }
}

export class ContabilidadContenido {

  KEY: string;
  VALORES: ContabilidadValor[];
  constructor() { }

  static toModel(json: string): ContabilidadContenido {
    const data = JSON.parse(json);
    if (data === null) {
      return null;
    }

    const toReturn = new ContabilidadContenido();

    toReturn.KEY = data.KEY;
    toReturn.VALORES = data.VALORES.map(valor => ContabilidadValor.toModel(JSON.stringify(valor)));

    return toReturn;
  }
}

export class ContabilidadValor {
  Id: number;
  NOMBRE: string;
  DESCRIPCION: string;
  TIPO: string;
  CHECKED: boolean;
  VALORES_COMBO: ContabilidadValorCombo[];
  comboboxConceptoSelected: string;
  constructor() { }

  static toModel(json: string): ContabilidadValor {
    const data = JSON.parse(json);
    if (data === null) {
      return null;
    }

    const toReturn = new ContabilidadValor();

    toReturn.Id = data.Id;
    toReturn.NOMBRE = data.NOMBRE;
    toReturn.DESCRIPCION = data.DESCRIPCION;
    toReturn.TIPO = data.TIPO;
    toReturn.CHECKED = data.CHECKED;
    const valoresCombo: ContabilidadValorCombo[] = data.VALORES_COMBO.map(valorCombo => ContabilidadValorCombo.toModel(JSON.stringify(valorCombo)));
    toReturn.VALORES_COMBO = valoresCombo.sort((x, y) => x.ORDEN - y.ORDEN);

    return toReturn;
  }
}

export class ContabilidadValorCombo {
  Id: number;
  NOMBRE: string;
  ORDEN: number;
  VALOR: string;
  CANTIDAD: number;
  constructor() { }

  static toModel(json: string): ContabilidadValorCombo {
    const data = JSON.parse(json);
    if (data === null) {
      return null;
    }

    const toReturn = new ContabilidadValorCombo();

    toReturn.Id = data.Id;
    toReturn.NOMBRE = data.NOMBRE;
    toReturn.ORDEN = data.ORDEN;
    toReturn.VALOR = data.VALOR;
    toReturn.CANTIDAD = data.CANTIDAD;

    return toReturn;
  }
}

export class ContabilidadOption {
  ID: number;
  PARAM: ContabilidadOptionValue;
  constructor() { }
}
export class ContabilidadOptionValue {
  Id: number;
  label: string;
  cantidad: number;
}


export class ActualizaConcepto {
  ID_CONTENIDO: number;
  ID_CONCEP_CONT_SERV: number;
  ID_CONC_CONT_TVAL: number;
  CANTIDAD: number;
  constructor() { }
}

export class ActualizaEstadosContenido {
  ID_CONTENIDO: number;
  ID_ESTADO: number;
  ID_SITUACION: number;
  constructor() { }
}

export class ActualizaEstadosSolicitud {
  ID_SOLICITUD_SERVICIO: number;
  ID_ESTADO: number;
  ID_SITUACION: number;
  constructor() { }
}

export class FechaSLA {
  FECHA_SLA: String;
  ID_SOLICITUD: number;
  constructor() { }
}

export class EstadosSolicitud {
  Id: number;
  ID_SIT_EST_DOCOUT: number;
  ID_SIT_EST_CLIENTE: string;
  ID_SERVI_CLI: string;
  SERVICIO_CONTENIDO: string;
  INICIAL: boolean;
  FINAL: boolean;
  PDTE_APROBACION: boolean;
  CANCELADA: boolean;
  INCIDENCIA: boolean;
  NO_AUTH: boolean;
}

export class TableInfo {
  columnsCampos: TableColumn[];
  columns: TableColumn[];
  exportColumns: { name: string, prop: string, isStatic: boolean }[];
  rows: TableContentInfo[] | SolicitudMaterial[];
  hasColumnRelationRequest: boolean;
  singleSelected: TableContentInfo[];
  columnsMultivalue: TableColumn[];
  page: Page;

  constructor() {
    this.columnsMultivalue = [];
    this.singleSelected = [];
    this.columns = [];
    this.rows = [];
    this.columnsCampos = [];
    this.page = new Page();
    this.page.pageNumber = 0;
    this.page.size = 10;
  }
}

export class TableContentInfo {
  contenidoRelacionado: number;
  campos: any[] = [];
  estadoGen: number;
  fechaExpiracion: Date;
  expirado: boolean;
  fechaFinalizacion: Date;
  fechaInicio: Date;
  fechaEntrada: Date;
  fechaRealFin: Date;
  ficheros: Fichero[];
  contenidoId: number;
  inventarioId: string;
  obsParcial: string;
  solicitudRelacionada: number;
  situacionId: number;
  situacionNombre: string;
  estadoId: number;
  estadoNombre: string;
  tipoUnidadDoc: number;
  isInventario: boolean;
  isParcial: boolean;
  idContenedor: number;
  numContenedor: number;
  proveedor: string;
  idProveedor: number;
  telefonoProveedor: string;
  correoProveedor: string;
  contactoProveedor: string;
  valoresExpediente: {
    NAME: string,
    PRINCIPAL: boolean,
    VALUE: string,
    ID: number
  }[];
}

export class FechaContenidos {
  DATE: string;
  IDS_CONTENIDOS: number[];
  constructor() { }
}

export class EstCambioProvAuto {
  IdSolicitudServicio: number;
  IdEstadoDestino: number;
  IdSituacionDestino: number;
  IdProveedorDestino: number;

}

export class DevolucionSinPrestamo {
  puedeHacerDevolucionSinPrestamo: boolean;
  puedeAdjuntarDocumentacion: boolean;

  constructor() { }

  static toModel(json: string): DevolucionSinPrestamo {
    const data = JSON.parse(json);
    if (data === null) {
      return null;
    }

    const toReturn = new DevolucionSinPrestamo();

    toReturn.puedeHacerDevolucionSinPrestamo = data.CanReturnWithoutLoan;
    toReturn.puedeAdjuntarDocumentacion = data.CanAttachmentFiles;

    return toReturn;
  }

}
